import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

/** Styles based on the new design tokens */
export const useStyles = makeStyles()((theme) => ({
	separator: {
		color: theme.accoTop.seperation.color,
		margin: `auto ${theme.spacing.xxsmall}`,

		'&::after': {
			content: '"|"',
		},
	},
}));
